import { BaseValidationDefinition, ValidationDefinition } from '../definitions'

/**
 * Extension of custom validation array that bridges custom validations
 * that are added to rows of list fields with the main entity context
 * in this way we can keep one centralized place where all custom validations
 * are collected and leverage the expression with matching row id to apply
 * the validation on the wanted row
 */
export class CustomRowValidations extends Array<BaseValidationDefinition> {
  private readonly entityCustomValidations: BaseValidationDefinition[]
  private readonly listName: string
  private readonly rowId: string

  constructor(entityCustomValidations: BaseValidationDefinition[], listName: string, rowId: string) {
    super()
    this.entityCustomValidations = entityCustomValidations
    this.listName = listName
    this.rowId = rowId
  }

  public override push(...items: BaseValidationDefinition[]): number {
    super.push(...items)
    items.forEach((i) => {
      const validation: ValidationDefinition = {
        field: i.field,
        condition: `row.id === '${this.rowId}'`,
        msgCode: i.msgCode,
        validationType: 'Expression',
        onList: this.listName,
        msgParameters: i.msgParameters,
      }
      this.entityCustomValidations.push(validation)
    })
    return this.length
  }
}
